export const PENDING = "SAVE_PENDING";
export const SUCCESS = "SAVE_SUCCESS";
export const FAILED = "SAVE_FAILED";
